import React from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/util/analytics";

export const AnalyticsTracker = () => {
  const location = useLocation();

  React.useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};
